export default function initFrmForms() : void {
    const frmForm:HTMLFormElement = document.querySelector('.frm_pro_form ');
    new FrmForms(frmForm);
};

class FrmForms {
    constructor($form: HTMLFormElement) {
        if ($form) {
            this.materialForm($form)
            this.progressBar($form)
            this.popins($form)
        }
    }

    materialForm($form: HTMLFormElement):void {
        $form?.querySelectorAll('.form-field-input').forEach( function (formField) {
            const $input:HTMLInputElement = formField.querySelector('input')

            if ($input && $input.value !== '') {
                formField.classList.add('is-focused')
            }
            $input?.addEventListener('focusin', (e) => formField.classList.add('is-focused'));
            $input?.addEventListener('change', (e) => formField.classList.add('is-focused'));
            $input?.addEventListener('focusout', (e) => {
                if (e.target.value === '') {
                    formField.classList.remove('is-focused')
                }
            });
        })
        $form?.querySelectorAll('.form-field-select').forEach( function (formField) {
            const $select:HTMLSelectElement = formField.querySelector('select')

            if ($select && $select.value !== '') {
                formField.classList.add('is-focused')
            }
            $select?.addEventListener('change', (e) => {
                if (e.target.value) {
                    formField.classList.add('is-focused')
                } else {
                    formField.classList.remove('is-focused')
                }
            });
        })
        if (document.querySelector('.register-talents .frm_message')) {
            document.querySelector('.register-talents').classList.add('form-done');
            document.querySelector('.header-page').remove()
            document.querySelector('.logo-talent').remove()
        }
    }

    progressBar($form: HTMLFormElement):void {
        const $progressBarRouteline:HTMLElement = $form.querySelector('.frm_rootline_group');
        const $lis:NodeListOf<HTMLLIElement> = $progressBarRouteline?.querySelectorAll('li');
        const BreakException = {};

        try {
            $lis.forEach(($li) => {
                if (!$li.classList.contains('frm_current_page')) {
                    $li.classList.add('frm_done')
                } else {
                    throw BreakException
                }
            })
        } catch (e) {
            if (e !== BreakException) throw e
        }


    }

    popins ($form: HTMLFormElement):void {
        const isAlreadySeen = this.getCookie('popin-concours-1')
        if (!isAlreadySeen && $form.querySelector('.frm_page_num_1') && !$form.querySelector('.frm_error_style')) {
            document.querySelector('#popin-concours-1')?.classList.add('open')
            this.setCookie('popin-concours-1', 1, 1);
        }
    }

    setCookie(name, value, days = 1) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Set expiration (1 day)
        let expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
    }

    getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            let [cookieName, cookieValue] = cookies[i].split('=');
            if (cookieName === name) {
                return cookieValue;
            }
        }
        return null; // Return null if cookie not found
    }

}